import {LIST_FLEET_GROUP, CREATE_FLEET_GROUP, UPDATE_FLEET_GROUP, DELETE_FLEET_GROUP, LIST_LEVEL} from "../constant";
import axios from 'axios';
import * as REPO from '../helper/main'

const localKey = 'token';

export const getListFleetGroup = () => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(LIST_FLEET_GROUP, config_token);
};
export const getListLevel = () => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(LIST_LEVEL, config_token);
};

export const postFleetGroup = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_FLEET_GROUP, data, config_token);
};

export const updateFleetGroup = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_FLEET_GROUP + id, data, config_token);
};

export const deleteFleetGroup = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.delete(DELETE_FLEET_GROUP + id, config_token);
};
